import { LogLevel } from "@azure/msal-browser";
/**
 * Azure AD Configuration for OAuth 2.0 authentication
 *
 * IMPORTANT: Set the following environment variables in .env.local:
 * - VITE_AZURE_AD_CLIENT_ID: The Application (client) ID from your Azure app registration
 * - VITE_AZURE_AD_TENANT_ID: Your Azure AD tenant ID
 */

const msalConfig: any = {
	auth: {
		clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID}`,
		redirectUri: window.location.origin,
		postLogoutRedirectUri: window.location.origin,
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: true,
	},
	system: {
		loggerOptions: {
			loggerCallback: (level: any, message: any, containsPii: any) => {
				if (containsPii) {
					return;
				}
				// Only log errors
				if (level === LogLevel.Error) {
					console.error(message);
				}
			},
		},
	},
};

const loginRequest = {
	scopes: ["User.Read"],
};

export { msalConfig, loginRequest };
